import { render } from "./RoadmapItem.vue?vue&type=template&id=5d1baf5e&scoped=true"
import script from "./RoadmapItem.vue?vue&type=script&lang=js"
export * from "./RoadmapItem.vue?vue&type=script&lang=js"

import "./RoadmapItem.vue?vue&type=style&index=0&id=5d1baf5e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1baf5e"]])

export default __exports__